var ip="192.168.1.8";
var port="12345";

//var url = window.location.protocol + "//fm.meitrack.com:54323/";
var url = window.location.protocol + "//fm1.meitrack.com:53561/";
var trackerSettingsUrl = window.location.protocol + "//fm.meitrack.com/trackerSettings/main.html";

var myfunction = {
	getip:function(){
		return ip;
	},
	getport:function(){
		return port;
	},
	geturl:function(){
		return url;
	},
	trackerSetUrl:function(){
		return trackerSettingsUrl;
	}

}

export default myfunction